/* eslint-disable react/prop-types */
import styled from 'styled-components';
import { useState } from 'react';
import Dialog from '@comp/Dialog/Dialog';
import ShareDialog from '@comp/ShareDialog/ShareDialog';
import Button from '@base/Button/Button';
import Share from '@icon/Share';
import boxShadowGenerator from '@utils/boxShadowGenerator';
import imageHelper from '@utils/imageHelper';
import BlocksWrapper from './BlocksWrapper';

const Wrapper = styled(BlocksWrapper)`
  height: 444px;
  background: #ffffff;
  box-shadow: ${({ theme }) => boxShadowGenerator({ theme })};
  border-radius: 8px;
  padding-left: 80px;
  @media only screen and (max-width: 540px) {
    flex-direction: column-reverse;
    height: auto;
    width: 92%;
    padding: 24px;
    margin: auto 16px;
    margin-bottom: 80px;
  }
`;

const LeftColumn = styled.div`
  max-width: 418px;
  margin: auto 0;
`;

const Heading = styled.p`
  font-weight: bold;
  font-size: 40px;
  line-height: 120%;
  color: #3c4852;
  margin-bottom: 16px;
  @media only screen and (max-width: 540px) {
    font-size: 24px;
  }
`;

const SubHeading = styled.p`
  font-weight: normal;
  font-size: 20px;
  line-height: 150%;
  color: #3c4852;
  margin-bottom: 40px;
  @media only screen and (max-width: 540px) {
    font-size: 16px;
  }
`;

const ShareButton = styled(Button)`
  @media only screen and (max-width: 540px) {
    margin: auto;
  }
`;

const RightColumn = styled.div`
  margin-left: 52px;
  position: relative;
  @media only screen and (max-width: 540px) {
    margin-left: 0;
  }
`;

const ShareVideo = styled.video`
  width: 587px;
  height: 421px;
  @media only screen and (max-width: 540px) {
    width: 100%;
    height: unset;
  }
`;

const ShareBlock = ({ dataSet }) => {
  const [showShareOptions, setShowShareOptions] = useState(false);
  const onShareClick = () => {
    setShowShareOptions(true);
  };

  const { shareData } = dataSet;
  const { title, subTitle, shareLink, shareText } = shareData || {};
  return (
    <>
      <Wrapper>
        <LeftColumn>
          <Heading>{title}</Heading>
          <SubHeading>{subTitle}</SubHeading>
          <ShareButton
            grid={3}
            label="Share"
            onClick={onShareClick}
            theme="black"
            icon={<Share size="20px" color="#3c4852" />}
            variant="hollow"
          />
        </LeftColumn>
        <RightColumn>
          <ShareVideo loop autoPlay playsInline muted>
            <source
              src={imageHelper.getImage('prodigy/invite-friends.mp4')}
              type="video/mp4"
            />
          </ShareVideo>
        </RightColumn>
      </Wrapper>
      <Dialog
        onClose={() => setShowShareOptions(false)}
        dialogState={showShareOptions}
      >
        <ShareDialog
          data={{ permalink: shareLink }}
          useDataLink
          twitterText={shareText}
        />
      </Dialog>
    </>
  );
};

export default ShareBlock;
